var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9060_132003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4955 16.6304H11.5195V20.2892H22.4955V16.6304Z",
    fill: "#D1FF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.155 11.1424H22.4961V16.631H26.155V11.1424Z",
    fill: "#D1FF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5189 20.2899H7.85938V21.2045V22.1197V25.7779H11.5183V22.1197H11.5189V20.2899Z",
    fill: "#D1FF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4955 7.48352H11.5189H10.9928H7.85938V14.8013V15.9693V16.631H11.5189V15.9693V14.8013V11.1424H22.4955V7.48352Z",
    fill: "#D1FF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4955 16.6304H11.5195V20.2892H22.4955V16.6304Z",
    fill: "#D1FF52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9060_132003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPha);
export default __webpack_public_path__ + "static/media/PHA.cba4e97565c5da7263a2a99c3ec6dcb5.svg";
export { ForwardRef as ReactComponent };